export default "__VITE_ASSET__DEUujjys__"